import { inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStoreFeature, withHooks, withMethods, withState } from '@ngrx/signals';
import { filter } from 'rxjs';
import { AIState } from 'stream-chat';
import { ChannelService, ChatClientService } from 'stream-chat-angular';

type AiChatState = {
  ai_status: AIState | '';
};

export function withAiChatStatus() {
  return signalStoreFeature(
    withState<AiChatState>({ ai_status: '' }),
    withMethods((store) => {
      function setAiStatusFromChannelData(channelData: Record<string, any> | undefined) {
        const state = (channelData?.['ai_state'] as AIState) || '';
        patchState(store, { ai_status: state });
      }

      return { setAiStatusFromChannelData };
    }),
    withHooks({
      onInit: (store, chatClientService = inject(ChatClientService), channelService = inject(ChannelService)) => {
        chatClientService.events$
          .pipe(
            takeUntilDestroyed(),
            filter((e) => e.eventType === 'channel.updated'),
            tapResponse({
              next: (e: any) => {
                if (e.event.channel?.id === channelService.activeChannel?.id) {
                  store.setAiStatusFromChannelData(e.event.channel);
                }
              },
              error: (error) => {
                console.error('Error updating AI status:', error);
              },
            })
          )
          .subscribe();

        channelService.activeChannel$
          .pipe(
            takeUntilDestroyed(),
            filter((ch) => !!ch),
            tapResponse({
              next: (channel: any) => {
                store.setAiStatusFromChannelData(channel.data);
              },
              error: (error) => {
                console.error('Error reading initial AI status from channel:', error);
              },
            })
          )
          .subscribe();
      },
    })
  );
}
